module.exports = __webpack_public_path__ + "media/tnbox.103252d9.mp4";